/**
 * Do not edit directly
 * Generated on Tue, 23 Jul 2024 13:51:28 GMT
 */

module.exports = {text : {emphasis:{
            name: "text.emphasis",
            hex: "#FFFFFF",
            description: "Used for any text content and icons used with text that needs emphasizing"
          },body:{
            name: "text.body",
            hex: "#E8E9EA",
            description: "Used for default text content and icons used with text"
          },subdued:{
            name: "text.subdued",
            hex: "#BCBDBF",
            description: "Used for any text content and icons used with text that requires less prominence"
          },onBackground:{
            name: "text.onBackground",
            hex: "#FFFFFF",
            description: "For use on darker or colour profile backgrounds that require highly contrasted text"
          }},
system : {textLabelEmphasis:{
            name: "system.textLabelEmphasis",
            hex: "#FFFFFF",
            description: "Used for any text content and icons used with text that needs emphasizing"
          },textBase:{
            name: "system.textBase",
            hex: "#BCBDBF",
            description: "Used as the text or fill colour for interactive and static system components such as links, text, and icons"
          },textHover:{
            name: "system.textHover",
            hex: "#E8E9EA",
            description: "Used as the hovered text or fill colour for interactive system components such as links and text buttons"
          },textActive:{
            name: "system.textActive",
            hex: "#FFFFFF",
            description: "Used as the pressed text or fill colour for interactive system components such as links and text buttons"
          },backgroundBase:{
            name: "system.backgroundBase",
            hex: "#141719",
            description: "Used as the background for system components"
          },backgroundMuted:{
            name: "system.backgroundMuted",
            hex: "#22272B",
            description: "Used as the muted background for system components"
          },backgroundMutedHover:{
            name: "system.backgroundMutedHover",
            hex: "#2D3238",
            description: "Used as the hovered muted background for system components"
          },backgroundMutedActive:{
            name: "system.backgroundMutedActive",
            hex: "#515357",
            description: "Used as the pressed muted background for system components"
          },backgroundBox:{
            name: "system.backgroundBox",
            hex: "#1D2124",
            description: "Used as a background colour for a system container like Box or Message"
          },borderBase:{
            name: "system.borderBase",
            hex: "#686B70",
            description: "Used for the border colour for system components"
          },borderHover:{
            name: "system.borderHover",
            hex: "#98999B",
            description: "Used for the hovered border colour for system components"
          },borderActive:{
            name: "system.borderActive",
            hex: "#BCBDBF",
            description: "Used for the pressed border colour for system components"
          },borderFocused:{
            name: "system.borderFocused",
            hex: "#6597CE",
            description: "Used for the focused border colour for system components"
          }},
surface : {level0:{
            name: "surface.level0",
            hex: "#141719",
            description: "Used for setting the lowest most level, mainly applied as a background color to the HTML body. Should always be underneath levels 1 and 2"
          },level1:{
            name: "surface.level1",
            hex: "#141719",
            description: "Used commonly with Boxes and containers that are directly on surface level 0. Also can be used as an alternative HTML body background color."
          },level2:{
            name: "surface.level2",
            hex: "#22272B",
            description: "Used for elements that are contained within Boxes or other wrappers that are surface level 1."
          },interactiveBackground:{
            name: "surface.interactiveBackground",
            hex: "#1D2124",
            description: "Used for elements where the entire surface is interactable. For example Accordions, ActionBlock, and DropdownItems"
          },interactiveHover:{
            name: "surface.interactiveHover",
            hex: "#22272B",
            description: "Hover state for elements where the entire surface is interactable. For example Accordions, ActionBlock, and DropdownItems"
          },interactiveActive:{
            name: "surface.interactiveActive",
            hex: "#2D3238",
            description: "Active/Pressed state for elements where the entire surface is interactable. For example Accordions, ActionBlock, and DropdownItems"
          },overlayDark:{
            name: "surface.overlayDark",
            hex: "#1D2124",
            description: "Used for elements that are absolutely positioned to overlay content on the page. Is always a dark background regardless of theme. Ex: Things like Toasts and Tooltips"
          },overlayTheme:{
            name: "surface.overlayTheme",
            hex: "#2D3238",
            description: "Used for elements that are absolutely positioned to overlay content on the page. Matches the base color of the theme. Ex: Snackbar"
          },overlayModal:{
            name: "surface.overlayModal",
            hex: "#1D2124",
            
          },overlayBackdrop:{
            name: "surface.overlayBackdrop",
            hex: "#000000",
            description: "Used to overlay & de-emphasize the page to draw focus to certain areas. Ex: Used with Modals, Drawers"
          },borderBase:{
            name: "surface.borderBase",
            hex: "#515357",
            
          },borderHover:{
            name: "surface.borderHover",
            hex: "#98999B",
            
          },borderActive:{
            name: "surface.borderActive",
            hex: "#BCBDBF",
            
          }},
primary : {textBase:{
            name: "primary.textBase",
            hex: "#1D2124",
            description: "Used as the text or fill colour for interactive and static primary components such as links, text, and icons"
          },textHover:{
            name: "primary.textHover",
            hex: "#1D2124",
            description: "Used as the hovered text or fill colour for interactive primary components such as links and text buttons"
          },textActive:{
            name: "primary.textActive",
            hex: "#1D2124",
            description: "Used as the pressed text or fill colour for interactive primary components such as links and text buttons"
          },backgroundBase:{
            name: "primary.backgroundBase",
            hex: "#E8E9EA",
            description: "Used as the background for primary components such as plain buttons. Paired with text.onBackground for contrast"
          },backgroundHover:{
            name: "primary.backgroundHover",
            hex: "#FFFFFF",
            description: "Used as the hovered background for primary components such as plain buttons"
          },backgroundActive:{
            name: "primary.backgroundActive",
            hex: "#FFFFFF",
            description: "Used as the hovered background for primary components such as plain buttons"
          },backgroundMuted:{
            name: "primary.backgroundMuted",
            hex: "#22272B",
            description: "Used as the muted background for primary components such as pills and text buttons. Paired with primary.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "primary.backgroundMutedHover",
            hex: "#2D3238",
            description: "Used as the hovered muted background for primary components such as pills and text buttons. Paired with primary.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "primary.backgroundMutedActive",
            hex: "#515357",
            description: "Used as the pressed muted background for primary components such as pills and text buttons. Paired with primary.textBase for a subtler contrast"
          },backgroundBox:{
            name: "primary.backgroundBox",
            hex: "#0C291E",
            description: "Used as a very light background for primary components such as Message and Box. Used for containers with content blocks"
          },borderBase:{
            name: "primary.borderBase",
            hex: "#515357",
            description: "Used for the border colour for primary components such as buttons and Message"
          },borderHover:{
            name: "primary.borderHover",
            hex: "#98999B",
            description: "Used for the hovered border colour for primary components such as buttons"
          },borderActive:{
            name: "primary.borderActive",
            hex: "#BCBDBF",
            description: "Used for the pressed border colour for primary components such as buttons"
          }},
success : {textBase:{
            name: "success.textBase",
            hex: "#42AD86",
            description: "Used as the text or fill colour for successful intention versions of components such as message, pill, or box"
          },textHover:{
            name: "success.textHover",
            hex: "#BFE8D9",
            description: "Used as the hovered text or fill colour for successful intention versions of components such as message, pill, or box"
          },textActive:{
            name: "success.textActive",
            hex: "#F0FFF9",
            description: "Used as the pressed text or fill colour for successful intention versions of components such as message, pill, or box"
          },backgroundBase:{
            name: "success.backgroundBase",
            hex: "#288563",
            description: "Description to come."
          },backgroundHover:{
            name: "success.backgroundHover",
            hex: "#42AD86",
            description: "Description to come."
          },backgroundActive:{
            name: "success.backgroundActive",
            hex: "#BFE8D9",
            description: "Description to come."
          },backgroundMuted:{
            name: "success.backgroundMuted",
            hex: "#124935",
            description: "Used as the muted background for successful intention versions of components such as message, pill, or box. Paired with successful.textBase for a subtler contrast."
          },backgroundMutedHover:{
            name: "success.backgroundMutedHover",
            hex: "#1F5B45",
            description: "Used as the hovered muted background for successful intention versions of components such as message, pill, or box. Paired with successful.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "success.backgroundMutedActive",
            hex: "#206A4F",
            description: "Used as the pressed muted background for successful intention versions of components such as message, pill, or box. Paired with successful.textBase for a subtler contrast"
          },backgroundBox:{
            name: "success.backgroundBox",
            hex: "#0C291E",
            description: "Used as a very light background for successful intention versions of components such as message, pill, or box. Used for containers with content blocks"
          },borderBase:{
            name: "success.borderBase",
            hex: "#206A4F",
            description: "Used for the border colour for successful intention versions of components such as buttons and Message"
          },borderHover:{
            name: "success.borderHover",
            hex: "#288563",
            description: "Used for the hovered border colour for successful components such as message"
          },borderActive:{
            name: "success.borderActive",
            hex: "#42AD86",
            description: "Used for the pressed border colour for successful components such as message"
          }},
info : {textBase:{
            name: "info.textBase",
            hex: "#6597CE",
            description: "Used as the text or fill colour for interactive and static informational components such as links, text, and icons"
          },textHover:{
            name: "info.textHover",
            hex: "#96BDE7",
            description: "Used as the hovered colour for interactive informational components such as links and text buttons"
          },textActive:{
            name: "info.textActive",
            hex: "#D1E8FF",
            description: "Used as the pressed colour for interactive informational components such as links and text buttons"
          },backgroundBase:{
            name: "info.backgroundBase",
            hex: "#4577AD",
            description: "Used as the background for informational components such as plain buttons. Paired with text.onBackground for contrast"
          },backgroundHover:{
            name: "info.backgroundHover",
            hex: "#285685",
            description: "Used as the hovered background for informational components such as plain buttons"
          },backgroundActive:{
            name: "info.backgroundActive",
            hex: "#142C45",
            description: "Used as the pressed background for informational components such as plain buttons"
          },backgroundMuted:{
            name: "info.backgroundMuted",
            hex: "#102337",
            description: "Used as the muted background for informational components such as pills and text buttons. Paired with info.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "info.backgroundMutedHover",
            hex: "#142C45",
            description: "Used as the hovered muted background for informational components such as pills and text buttons. Paired with info.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "info.backgroundMutedActive",
            hex: "#285685",
            description: "Used as the pressed muted background for informational components such as pills and text buttons. Paired with info.textBase for a subtler contrast"
          },backgroundBox:{
            name: "info.backgroundBox",
            hex: "#0C1B29",
            description: "Used as a very light background for informational components such as Message and Box. Used for containers with content blocks"
          },borderBase:{
            name: "info.borderBase",
            hex: "#4577AD",
            description: "Used for the border colour for informational components such as buttons and Message"
          },borderHover:{
            name: "info.borderHover",
            hex: "#285685",
            description: "Used for the hovered border colour for informational components such as buttons"
          },borderActive:{
            name: "info.borderActive",
            hex: "#142C45",
            description: "Used for the pressed border colour for informational components such as buttons"
          }},
warning : {textBase:{
            name: "warning.textBase",
            hex: "#CF7945",
            description: "Used as the text or fill colour for interactive and static warning components such as links, text, and icons"
          },textHover:{
            name: "warning.textHover",
            hex: "#E7AA84",
            description: "Used as the hovered text or fill colour for interactive and static warning components such as links and text buttons"
          },textActive:{
            name: "warning.textActive",
            hex: "#FFE3D1",
            description: "Used as the pressed text or fill colour for interactive and static warning components such as links and text buttons"
          },backgroundBase:{
            name: "warning.backgroundBase",
            hex: "#AD6234",
            description: "Used as the background for warning components such as plain buttons. Paired with text.onBackground for contrast"
          },backgroundHover:{
            name: "warning.backgroundHover",
            hex: "#CF7945",
            description: "Used as the hovered background for warning components such as plain buttons"
          },backgroundActive:{
            name: "warning.backgroundActive",
            hex: "#E7AA84",
            description: "Used as the pressed background for warning components such as plain buttons"
          },backgroundMuted:{
            name: "warning.backgroundMuted",
            hex: "#4A2915",
            description: "Used as the muted background for warning components such as pills and text buttons. Paired with warning.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "warning.backgroundMutedHover",
            hex: "#63371C",
            description: "Used as the hovered muted background for warning components such as pills and text buttons. Paired with warning.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "warning.backgroundMutedActive",
            hex: "#8A4E29",
            description: "Used as the pressed muted background for warning components such as pills and text buttons. Paired with warning.textBase for a subtler contrast"
          },backgroundBox:{
            name: "warning.backgroundBox",
            hex: "#29170C",
            description: "Used as a very light background for warning components such as Message and Box. Used for containers with content blocks"
          },borderBase:{
            name: "warning.borderBase",
            hex: "#8A4E29",
            description: "Used for the border colour for warning components such as buttons and Message"
          },borderHover:{
            name: "warning.borderHover",
            hex: "#AD6234",
            description: "Used for the hovered border colour for warning components"
          },borderActive:{
            name: "warning.borderActive",
            hex: "#CF7945",
            description: "Used for the pressed border colour for warning components such as buttons"
          }},
danger : {textBase:{
            name: "danger.textBase",
            hex: "#C74C6B",
            description: "Used as the text or fill colour for interactive and static danger components such as links, text, and icons"
          },textHover:{
            name: "danger.textHover",
            hex: "#EA8AA3",
            description: "Used as the hovered colour for interactive danger components such as links and text buttons"
          },textActive:{
            name: "danger.textActive",
            hex: "#FFD1DD",
            description: "Used as the pressed colour for interactive danger components such as links and text buttons"
          },backgroundBase:{
            name: "danger.backgroundBase",
            hex: "#B23655",
            description: "Used as the background for danger components such as plain buttons. Paired with text.onBackground for contrast"
          },backgroundHover:{
            name: "danger.backgroundHover",
            hex: "#C74C6B",
            description: "Used as the hovered background for danger components such as plain buttons"
          },backgroundActive:{
            name: "danger.backgroundActive",
            hex: "#EA8AA3",
            description: "Used as the pressed background for danger components such as plain buttons"
          },backgroundMuted:{
            name: "danger.backgroundMuted",
            hex: "#451522",
            description: "Used as the muted background for danger components such as pills and text buttons. Paired with danger.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "danger.backgroundMutedHover",
            hex: "#5E1D2E",
            description: "Used as the hovered muted background for danger components such as pills and text buttons. Paired with danger.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "danger.backgroundMutedActive",
            hex: "#8F2843",
            description: "Used as the pressed muted background for danger components such as pills and text buttons. Paired with danger.textBase for a subtler contrast"
          },backgroundBox:{
            name: "danger.backgroundBox",
            hex: "#290F16",
            description: "Used as a very light background for warning components such as Message and Box. Used for containers with content blocks"
          },borderBase:{
            name: "danger.borderBase",
            hex: "#8F2843",
            description: "Used for the border colour for danger components such as buttons and Message"
          },borderHover:{
            name: "danger.borderHover",
            hex: "#B23655",
            description: "Used for the hovered border colour for danger components such as buttons"
          },borderActive:{
            name: "danger.borderActive",
            hex: "#C74C6B",
            description: "Used for the pressed border colour for danger components such as buttons"
          }},
highlight : {textBase:{
            name: "highlight.textBase",
            hex: "#865C99",
            description: "Used as the text or fill colour for interactive and static highlight components such as links, text, and icons"
          },textHover:{
            name: "highlight.textHover",
            hex: "#B990CC",
            description: "Used as the hovered text or fill colour for interactive and static highlight components such as links and text buttons"
          },textActive:{
            name: "highlight.textActive",
            hex: "#F0D1FF",
            description: "Used as the pressed text or fill colour for interactive and static highlight components such as links and text buttons"
          },backgroundBase:{
            name: "highlight.backgroundBase",
            hex: "#693B80",
            description: "Used as the background for highlight components such as plain buttons. Paired with text.onBackground for contrast"
          },backgroundHover:{
            name: "highlight.backgroundHover",
            hex: "#865C99",
            description: "Used as the hovered background for highlight components such as plain buttons"
          },backgroundActive:{
            name: "highlight.backgroundActive",
            hex: "#B990CC",
            description: "Used as the pressed background for highlight components such as plain buttons"
          },backgroundMuted:{
            name: "highlight.backgroundMuted",
            hex: "#33193F",
            description: "Used as the muted background for highlight components such as pills and text buttons. Paired with highlight.textBase for a subtler contrast"
          },backgroundMutedHover:{
            name: "highlight.backgroundMutedHover",
            hex: "#482359",
            description: "Used as the hovered muted background for highlight components such as pills and text buttons. Paired with highlight.textBase for a subtler contrast"
          },backgroundMutedActive:{
            name: "highlight.backgroundMutedActive",
            hex: "#542F66",
            description: "Used as the pressed muted background for highlight components such as pills and text buttons. Paired with highlight.textBase for a subtler contrast"
          },backgroundBox:{
            name: "highlight.backgroundBox",
            hex: "#200F29",
            description: "Used as a very light background for highlight components such as Message and Box. Used for containers with content blocks"
          },borderBase:{
            name: "highlight.borderBase",
            hex: "#542F66",
            description: "Used for the border colour for highlight components such as buttons and Message"
          },borderHover:{
            name: "highlight.borderHover",
            hex: "#693B80",
            description: "Used for the hovered border colour for highlight components"
          },borderActive:{
            name: "highlight.borderActive",
            hex: "#865C99",
            description: "Used for the pressed border colour for highlight components such as buttons and Message"
          }},
disabled : {text:{
            name: "disabled.text",
            hex: "#98999B",
            description: "For use in disabled content like text and icons"
          },background:{
            name: "disabled.background",
            hex: "#22272B",
            description: "Used as the background colour for disabled components"
          },nakedBackground:{
            name: "disabled.nakedBackground",
            hex: "transparent",
            description: "Used for the background in disabled components with little to no styling"
          },border:{
            name: "disabled.border",
            hex: "#515357",
            description: "Used as the border for disabled components"
          },nakedContent:{
            name: "disabled.nakedContent",
            hex: "#22272B",
            
          },inputBackground:{
            name: "disabled.inputBackground",
            hex: "#2D3238",
            description: "For use in disabled inputs as the background colour"
          },inputLabelText:{
            name: "disabled.inputLabelText",
            hex: "#98999B",
            description: "Used as the label colour for disabled inputs"
          }},
input : {backgroundBase:{
            name: "input.backgroundBase",
            hex: "#1B2228",
            description: "Used as the default background colour for HTML inputs"
          },backgroundHover:{
            name: "input.backgroundHover",
            hex: "#2D3238",
            description: "Used as the hovered background colour for HTML inputs"
          },backgroundInformation:{
            name: "input.backgroundInformation",
            hex: "#FFFFFF",
            description: "Used as the default background colour for the text description below the input"
          },textBase:{
            name: "input.textBase",
            hex: "#FFFFFF",
            description: "Used for the default filled text colour for HTML inputs"
          },textInformation:{
            name: "input.textInformation",
            hex: "#BCBDBF",
            description: "Used as the text content colour for the text description below the input"
          },textInformationError:{
            name: "input.textInformationError",
            hex: "#B23655",
            description: "Used as the text content colour for the text description below the input when there are errors"
          },textLabel:{
            name: "input.textLabel",
            hex: "#BCBDBF",
            description: "Used as the default static label colour in HTML inputs which appears as a placeholder in the static state"
          },textFloatingLabel:{
            name: "input.textFloatingLabel",
            hex: "#4577AD",
            description: "Used as the floated label colour when the HTML input has focus"
          },textFloatingLabelError:{
            name: "input.textFloatingLabelError",
            hex: "#B23655",
            description: "Used as the static and floated label colour when the input is in an error state"
          },textPlaceholder:{
            name: "input.textPlaceholder",
            hex: "#98999B",
            description: "Used as the default placeholder text colour for basic and search inputs"
          },textActive:{
            name: "input.textActive",
            hex: "#FFFFFF",
            description: "Used as the label colour for labels that don't float when focused, like the select component"
          },borderBase:{
            name: "input.borderBase",
            hex: "#2D3238",
            description: "Used as the default border colour"
          },borderError:{
            name: "input.borderError",
            hex: "#8F2843",
            description: "Used for the border colour when the input is in an error state"
          },borderHover:{
            name: "input.borderHover",
            hex: "#515357",
            description: "Used as the hovered border colour"
          },borderEmphasized:{
            name: "input.borderEmphasized",
            hex: "#98999B",
            description: "Used as the default bottom border colour for floating label inputs or as the default border for inputs like checkbox"
          },borderEmphasizedHover:{
            name: "input.borderEmphasizedHover",
            hex: "#BCBDBF",
            description: "Used as the hovered bottom border colour for floating label inputs or as the hovered border for inputs like checkbox"
          },borderActive:{
            name: "input.borderActive",
            hex: "#285685",
            description: "Used as the pressed bottom border colour for floating label inputs or as the engaged border for inputs like checkbox"
          }},
separator : {base:{
            name: "separator.base",
            hex: "#515357",
            description: "Used for the colour of the separator element"
          }},
light : {backgroundBase:{
            name: "light.backgroundBase",
            hex: "#FFFFFF",
            description: "For use as background colour in light profile components on contrasting surface backgrounds"
          },backgroundContrast:{
            name: "light.backgroundContrast",
            hex: "#515357",
            description: "For use as a contrasting background colour in light profile components, to match shade of surface background"
          },backgroundHover:{
            name: "light.backgroundHover",
            hex: "#E8E9EA",
            description: "For use as background hover colour in light profile components on contrasting surface backgrounds"
          },backgroundActive:{
            name: "light.backgroundActive",
            hex: "#E8E9EA",
            description: "For use as background active colour in light profile components on contrasting surface backgrounds"
          },textBase:{
            name: "light.textBase",
            hex: "#2D3238",
            description: "Used as the content colour (text, icons) for light profile components, to match shade of constrasting surface background"
          },linkMutedBase:{
            name: "light.linkMutedBase",
            hex: "#E8E9EA",
            description: "Used as link colour for light profile components on contrasting surface backgrounds"
          },linkMutedHover:{
            name: "light.linkMutedHover",
            hex: "#FFFFFF",
            description: "Used for link hover colour for light profile components on contrasting surface backgrounds"
          }},
shadow : {base:{
            name: "shadow.base",
            hex: "#000000",
            description: "For use only with box shadow tokens"
          }},
accent : {forestTextBody:{
            name: "accent.forestTextBody",
            hex: "#BFE8D9",
            
          },forestTextEmphasis:{
            name: "accent.forestTextEmphasis",
            hex: "#F0FFF9",
            
          },forestBackgroundMuted0:{
            name: "accent.forestBackgroundMuted0",
            hex: "#124935",
            
          },forestBackgroundMuted1:{
            name: "accent.forestBackgroundMuted1",
            hex: "#1F5B45",
            
          },forestBackgroundMuted2:{
            name: "accent.forestBackgroundMuted2",
            hex: "#206A4F",
            
          },sandTextBody:{
            name: "accent.sandTextBody",
            hex: "#EFE5D1",
            
          },sandTextEmphasis:{
            name: "accent.sandTextEmphasis",
            hex: "#F6F1E5",
            
          },sandBackgroundMuted0:{
            name: "accent.sandBackgroundMuted0",
            hex: "#493612",
            
          },sandBackgroundMuted1:{
            name: "accent.sandBackgroundMuted1",
            hex: "#5E4317",
            
          },sandBackgroundMuted2:{
            name: "accent.sandBackgroundMuted2",
            hex: "#6B5024",
            
          }},
inverted : {backgroundBase:{
            name: "inverted.backgroundBase",
            hex: "#E8E9EA",
            
          },backgroundHover:{
            name: "inverted.backgroundHover",
            hex: "#BCBDBF",
            
          },backgroundActive:{
            name: "inverted.backgroundActive",
            hex: "#98999B",
            
          },textEmphasis:{
            name: "inverted.textEmphasis",
            hex: "#141719",
            
          },textBody:{
            name: "inverted.textBody",
            hex: "#1D2124",
            
          }},
secondary : {textBase:{
            name: "secondary.textBase",
            hex: "#FFFFFF",
            
          },textHover:{
            name: "secondary.textHover",
            hex: "#FFFFFF",
            
          },textActive:{
            name: "secondary.textActive",
            hex: "#FFFFFF",
            
          },backgroundBase:{
            name: "secondary.backgroundBase",
            hex: "#141719",
            
          },backgroundHover:{
            name: "secondary.backgroundHover",
            hex: "#22272B",
            
          },backgroundActive:{
            name: "secondary.backgroundActive",
            hex: "#2D3238",
            
          },borderBase:{
            name: "secondary.borderBase",
            hex: "#FFFFFF",
            
          },borderHover:{
            name: "secondary.borderHover",
            hex: "#E8E9EA",
            
          },borderActive:{
            name: "secondary.borderActive",
            hex: "#E8E9EA",
            
          }},
smart : {backgroundBase:{
            name: "smart.backgroundBase",
            hex: "linear-gradient(65deg, #8FA7C1 10.68%, #B0C1D4 38.02%, #C8D6E4 79.03%)",
            
          },backgroundHover:{
            name: "smart.backgroundHover",
            hex: "linear-gradient(65deg, #8FA7C1 10.68%, #B0C1D4 20.59%, #C8D6E4 32.55%)",
            
          },backgroundActive:{
            name: "smart.backgroundActive",
            hex: "linear-gradient(65deg, #B0C1D4 10.68%, #C8D6E4 20.59%, #DDE5EE 32.55%)",
            
          }},};